import { AddressLocationsEntity } from "../../domain/entities/address_locations_entity";
import http from "../../../../plugins/http-common"

export const HttpAddressLocationsRepository = {
  model: AddressLocationsEntity,

  async get_state_and_city(address) {

    const res = await http.get('https://locations.intech.mx/api/neighborhoods/zip_code/' + address.zipcode);

    if(res.data.length != 0){
      const result = await http.get('https://locations.intech.mx/api/getCityDetails/' + res.data[0].city_id);

      address.state = result.data.state.alt_names[0];
      address.city = result.data.city.name
    }
    
    return address;    
  },

  async get_state_from_country(country){
    const res = await http.get('https://locations.intech.mx/api/getStates/' + country);

    return res;
  },

  async get_cities_from_state(country, state) {
    const res = await http.get('https://locations.intech.mx/api/getCities/' + country + '/' + state);

    return res;
  },

  async get_countries() {
    const res = await http.get('https://locations.intech.mx/api/getCountries');

    return res;
  }
};